import { z } from "zod";
import { PRODUCT_TYPE_POLICIES, tickRateHzSchema } from "./product.js";
export const PREVIEW_TOTAL_CAPACITY = 250;
export const PRO_TOTAL_CAPACITY = 2500;
export const MAX_TOTAL_CAPACITY = 120_000_000;
export const MAX_SERVER_ALLOCATED_CCU = 4096;
export const MAX_SERVER_ALLOCATED_CAPACITY = PRODUCT_TYPE_POLICIES.game.maxTickRateHz * MAX_SERVER_ALLOCATED_CCU;
export function defaultTotalCapacity(accessLevel = "guest") {
    switch (accessLevel) {
        case "lite":
        case "admin":
            return PREVIEW_TOTAL_CAPACITY;
        case "pro":
            return PRO_TOTAL_CAPACITY;
        default:
            return 0;
    }
}
export const totalCapacitySchema = z.number().int().min(0).max(MAX_TOTAL_CAPACITY);
export const allocatedCcuSchema = z.number().int().min(1).max(MAX_SERVER_ALLOCATED_CCU);
export const allocatedCapacitySchema = z.number().int().min(1).max(MAX_SERVER_ALLOCATED_CAPACITY);
export function calculateCapacity(tickRateHz, allocatedCcu) {
    return tickRateHzSchema.parse(tickRateHz) * allocatedCcuSchema.parse(allocatedCcu);
}
export function maxAffordableCcu(availableCapacity, tickRateHz) {
    return Math.min(MAX_SERVER_ALLOCATED_CCU, Math.floor(totalCapacitySchema.parse(availableCapacity) / tickRateHzSchema.parse(tickRateHz)));
}
export const accountCapacitySchema = z
    .object({
    totalCapacity: totalCapacitySchema,
    allocatedCapacity: z.number().int().min(0).max(Number.MAX_SAFE_INTEGER),
    availableCapacity: totalCapacitySchema,
})
    .refine((value) => value.availableCapacity === Math.max(0, value.totalCapacity - value.allocatedCapacity), {
    message: "availableCapacity must equal max(0, totalCapacity - allocatedCapacity)",
    path: ["availableCapacity"],
});
export const AUDIENCE_ESTIMATE_MULTIPLIERS = { dau: 20, mau: 400 };
export const AUDIENCE_ESTIMATE_CAVEAT = "Rough audience estimates only, not guaranteed capacity: actual DAU and MAU depend on average playtime, session length, and usage patterns.";
export function estimateAudience(ccu) {
    const validatedCcu = z
        .number()
        .int()
        .min(0)
        .max(Math.floor(Number.MAX_SAFE_INTEGER / AUDIENCE_ESTIMATE_MULTIPLIERS.mau))
        .parse(ccu);
    return {
        estimatedDau: validatedCcu * AUDIENCE_ESTIMATE_MULTIPLIERS.dau,
        estimatedMau: validatedCcu * AUDIENCE_ESTIMATE_MULTIPLIERS.mau,
        caveat: AUDIENCE_ESTIMATE_CAVEAT,
    };
}
/** @deprecated Use PREVIEW_TOTAL_CAPACITY; legacy CCU budgets convert at 10 Hz. */
export const PREVIEW_TOTAL_CCU = 10;
/** @deprecated Use defaultTotalCapacity for new account budgets. */
export function defaultTotalCcu(accessLevel = "guest") {
    switch (accessLevel) {
        case "lite":
            return PREVIEW_TOTAL_CCU;
        case "pro":
        case "admin":
            return 100;
        default:
            return 0;
    }
}
/** @deprecated Retained for reading legacy limits.totalCcu, converted at 10 Hz. */
export const totalCcuSchema = z.number().int().min(0).max(1_000_000);
//# sourceMappingURL=account-capacity.js.map